import axios from "../../axios";
export default {
  namespaced: true,
  state: {
    table: {},
    vehicles: [],
  },
  mutations: {
    SET_TABLE(state, products) {
      state.table = products;
    },
    SET_VEHICLES(state, products) {
      let vehicles = [];
      if (products) {
        vehicles = products.results.map((el) => {
          return {
            label: `${el.vehicle_id}`,
            value: el.vehicle_id,
          };
        });

        vehicles = vehicles.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.value === item.value)
        );
      } else return;

      return (state.vehicles = vehicles);
    },
  },
  actions: {
    fetchUnitsTable({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get("event/iftareports", { params })
          .then((response) => {
            commit("SET_TABLE", response.data);
            resolve(response);
          })
          .catch((error) => {
            // console.log(error), reject(error);
          });
      });
    },
    fetchVehicles({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get("event/iftareports", { params })
          .then((response) => {
            commit("SET_VEHICLES", response.data);
            resolve(response);
          })
          .catch((error) => {
            // console.log(error), reject(error);
          });
      });
    },
    fetchStateTable({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get("event/iftareports/state/", { params })
          .then((response) => {
            commit("SET_TABLE", response.data);
            resolve(response);
          })
          .catch((error) => {
            // console.log(error), reject(error);
          });
      });
    },

    downloadPdfFile(_, params) {
      return new Promise((resolve, reject) => {
        axios
          .get("event/generate-pdf", {
            params,
            responseType: "blob", // Add this line to handle the file as a blob
          })
          .then((response) => {
            const fileType = "PDF";
            const blob = new Blob([response.data], { type: fileType });
            const url = window.URL.createObjectURL(blob);

            // Create a link to download the file
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `report.pdf`); // Set the file name and type
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            resolve(response);
          })
          .catch((error) => {
            console.error("File download error:", error);
            reject(error);
          });
      });
    },
    downloadCsvFile(_, params) {
      return new Promise((resolve, reject) => {
        axios
          .get("event/generate-csv", {
            params,
            responseType: "blob", // Add this line to handle the file as a blob
          })
          .then((response) => {
            const fileType = "text/csv";
            const blob = new Blob([response.data], { type: fileType });
            const url = window.URL.createObjectURL(blob);

            // Create a link to download the file
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `report.csv`); // Set the file name and type
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            resolve(response);
          })
          .catch((error) => {
            console.error("File download error:", error);
            reject(error);
          });
      });
    },
  },
};
